import { SCREEN_CARD_THUMBNAIL_WIDTH } from "../../../library/v2/ScreenCard/specs";
import { ScreenSnapshot } from "../../model/Snapshot";
import {
    calculateCropHeight,
    getResizedImageSources,
    getSnapshotThumbnailSourceData,
    SnapshotThumbnailSourceData
} from "../image";

function getScreenThumbnailImageSource(snapshot: ScreenSnapshot): SnapshotThumbnailSourceData {
    const thumbnailImageSource = getSnapshotThumbnailSourceData(snapshot.thumbnails);

    if (!thumbnailImageSource || thumbnailImageSource.status === "error") {
        const cropHeight = calculateCropHeight({
            width: snapshot.width,
            height: snapshot.height
        });

        const resizedImage = getResizedImageSources(snapshot.url, {
            width: SCREEN_CARD_THUMBNAIL_WIDTH,
            height: cropHeight
        });

        return {
            src: resizedImage.src,
            srcset: resizedImage.srcset,
            status: "ready"
        };
    }

    return thumbnailImageSource;
}

export { getScreenThumbnailImageSource };
